import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { ScrollView, Text, View } from 'react-native'
import { useCssStyle } from '../../customHook/getCssStyle';
import { useDispatch, useSelector } from 'react-redux';
import { setRenderFlashMessage } from '../../Redux/Actions/appConfigAction';
import HeaderWithBack from '../../components/Header/headerWithBack';
import CustomPressable from '../../components/customPressable/customPressable';
import moment from 'moment';
import DatePickerModal from '../../components/datePickerModal/datePickerModal';
import { ImageComp } from '../../components/Image/Image';
import { getCleanUrl } from '../../utils/Helper';
import { CustomTextInput } from '../../components/customTextInput';

const ReservationsAvailability = (props) => {
    const {selectedEvent, selectedVenue, preferredDateTime, setPreferredDateTime, handleNext, handleGoBack } = props;

    const { t } = useTranslation();
    const getStyles = useCssStyle();
    const dispatch = useDispatch();

    const { serverTimeDataObj } = useSelector(state => state.serverDateTimeSlice);
    const serverDateTime = new Date(serverTimeDataObj.date);
    const TIME_FORMAT = useSelector(state => state.deviceConfigSlice?.extraConfigParam?.TIME_FORMAT_MERIDIEM) || false;

    const { currentWidget, extraConfigParam } = useSelector(state => state.deviceConfigSlice);
    const dateFormat = extraConfigParam?.DATE_FORMAT;



    const [isDatePickerVisible, setIsDatePickerVisible] = useState(false);

    let acceptedDates;

    const isDayDisabled = (date) => {
        if(!acceptedDates){
            const venueId = selectedVenue.venueId;
            const event_= selectedEvent.events.find(event=>event.venueId==venueId)  ;
            acceptedDates= event_.applicable_dates
        }

        const serverDate = new Date(serverTimeDataObj?.date?.split("T")[0]);
        
        const isDateAccepted =()=>{
            // console.log(moment(date).format("MM/DD/YYYY"))
            if(acceptedDates.includes(moment(date).format("MM/DD/YYYY"))){
                return true;
            }
            return false;
        } ;



        return !isDateAccepted() || serverDate > new Date(date)
    }



    const handleGoNext = () => {

        if (preferredDateTime.date == "") {
            // .popupOpenClose(true, t("events.select_preferred_date"));
            dispatch(setRenderFlashMessage(true, {type: "danger", message: t("events.select_preferred_date")}))
            return;
        }

        if (isNaN(Number(preferredDateTime.guestCount)) || Number(preferredDateTime.guestCount) < 1) {
            // props.popupOpenClose(true, t("events.fill_valid_guestCount"));
            dispatch(setRenderFlashMessage(true, {type: "danger", message: t("events.fill_valid_guestCount")}))
            return;
        }



        handleNext();
    }

    const handleDateChange = (selectedDate) => {
        setIsDatePickerVisible(false);
        setPreferredDateTime({ ...props.preferredDateTime, date: moment(selectedDate).format('YYYY-MM-DD')});
    }

    
    const renderHeader = () => {
        return <View style={getStyles(['widgetmainContainerHeaderContainer', 'reservationsHeaderContainer'])}>
            {
                currentWidget?.widgetHeaderImageUrl &&
                <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'reservationsHeaderImg'])} />
            }
            <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'reservationsHeaderTitleContainer'])}>
                <Text style={getStyles(['widgetmainContainerHeaderTitle', 'reservationsHeaderTitle'])}>{t('events.heading4')}</Text>
            </View>
        </View>
    }
    return (
        <View style={getStyles(['widgetRootContainer', 'reservationsRootContainer'])}>
            <HeaderWithBack handleCustomBackPress={handleGoBack} />
                                    
            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'reservationsMainContainer'])} 
                showsVerticalScrollIndicator={false}
            >
                {renderHeader()}


                <View style={getStyles(['widgetmainContainerChildContainer', 'reservationsMainContainerChildContainer', {gap: 16, marginTop: 16}])}>
                    <View style={getStyles(['textContainer', 'reservationsFieldContainer'])} id='reservationsFieldContainer'>
                        <Text style={getStyles(['label'])}>{t("events.guestCount")} <Text style={{ color: "red" }}>*</Text></Text>
                        <View style={getStyles(['reservationsInputContainer'])} id='reservationsInputContainer'>
                            <CustomTextInput
                                value={preferredDateTime.guestCount}
                                onChangeText={(value) => setPreferredDateTime((prev) => ({...preferredDateTime, guestCount: value}))}
                                // placeholder={resp.placeholder}
                            />
                            <CustomPressable
                                disabled={isNaN(Number(preferredDateTime.guestCount)) || Number(preferredDateTime.guestCount) <= 1}
                                onPress={() => setPreferredDateTime((prev) => ({...preferredDateTime, guestCount: String(Number(preferredDateTime.guestCount) - 1)}))}
                                style={getStyles(['reservationsAddMinusContainer'])}
                            >
                                <Text style={getStyles(['reservationsAddMinusContainerTxt'])}>-</Text>
                            </CustomPressable>
                            <CustomPressable
                                disabled={isNaN(Number(preferredDateTime.guestCount))}
                                onPress={() => setPreferredDateTime((prev) => ({...preferredDateTime, guestCount: String(Number(preferredDateTime.guestCount) + 1)}))}
                                style={getStyles(['reservationsAddMinusContainer'])}
                            >
                                <Text style={getStyles(['reservationsAddMinusContainerTxt'])}>+</Text>
                            </CustomPressable>

                        </View>

                    </View>

                    <View style={getStyles(['textContainer', 'reservationsFieldContainer'])} id='reservationsFieldContainer'>
                        <Text style={getStyles(['label'])}>{t("events.preferred_date")} <Text style={{ color: "red" }}>*</Text></Text>
                        <View style={getStyles(['textContainer'])}>
                            <CustomPressable
                                onPress={() => setIsDatePickerVisible(!isDatePickerVisible)}
                            >
                                <CustomTextInput
                                    value={preferredDateTime.date ? moment(preferredDateTime.date).format((dateFormat).toUpperCase()) : ''}
                                    placeholder={t("events.select_date_placeholder")}
                                    editable={false}
                                    pointerEvents="none"
                                />
                            </CustomPressable>
                        </View>
                    </View>
                </View>

            </ScrollView>


            <View id='reservationsNextButtonContainer' style={getStyles(['reservationsNextButtonContainer'])}>
                <CustomPressable style={getStyles(["primaryBtn"])} onPress={()=> handleGoNext()} id="primaryBtn">
                    <Text style={getStyles(["primaryBtnTxt"])} id='primaryBtnTxt'>
                        {t("events.next")}
                    </Text>
                </CustomPressable>

                {/* <CustomPressable style={getStyles(["secondaryBtn"])} onPress={()=> handleGoBack()} id="secondaryBtn">
                    <Text style={getStyles(["secondaryBtnTxt"])} id='secondaryBtnTxt'>
                        {t("events.back")}
                    </Text>
                </CustomPressable> */}
            </View>


            {isDatePickerVisible &&
                <DatePickerModal
                    selectedDate={preferredDateTime.date == '' ? undefined : new Date(preferredDateTime.date)}
                    onDateChange={handleDateChange}
                    onClose={() => setIsDatePickerVisible(false)}
                />
            }
        </View>
    )
}

export default ReservationsAvailability
